import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "payee_entry"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", null, "振込先登録", -1);
const _hoisted_5 = { class: "inner" };
const _hoisted_6 = { class: "normal" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("dt", null, [
    /*#__PURE__*/ _createTextVNode(" 振込先"),
    /*#__PURE__*/ _createElementVNode("a", {
        class: "bt_change modal_win sp",
        "data-target": "bank-modal"
    }, "変更")
], -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "金融機関名", -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "支店名", -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "種別", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "口座名義", -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "口座番号", -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("a", {
    class: "bt_change modal_win pc",
    "data-target": "bank-modal"
}, "変更", -1);
const _hoisted_14 = {
    id: "receive-modal",
    class: "modal min2 js-modal"
};
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "modal-bg bt_modal_close" }, null, -1);
const _hoisted_16 = { class: "modal-content" };
const _hoisted_17 = { class: "close_bt bt_modal_close" };
const _hoisted_18 = { class: "pop" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("h2", null, "報酬", -1);
const _hoisted_20 = { class: "center" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", { for: "q1_a1" }, "受け取る", -1);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("label", {
    for: "q1_a2",
    style: { "margin-left": "6px" }
}, "受け取らない", -1);
const _hoisted_23 = { class: "bt_box clear" };
const _hoisted_24 = {
    id: "bank-modal",
    class: "modal type3 js-modal"
};
const _hoisted_25 = { class: "modal-content" };
const _hoisted_26 = { class: "close_bt bt_modal_close" };
const _hoisted_27 = { class: "pop" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("h2", null, "振込先登録", -1);
const _hoisted_29 = { class: "sec_2 last" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "金融機関コード", -1);
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("span", null, "（半角数字4桁）", -1);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_33 = {
    key: 0,
    class: "err"
};
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "金融機関名", -1);
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_36 = {
    key: 1,
    class: "err"
};
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "支店コード", -1);
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("span", null, "（半角数字3桁）", -1);
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_40 = {
    key: 2,
    class: "err"
};
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "支店名", -1);
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_43 = {
    key: 3,
    class: "err"
};
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "種別", -1);
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("label", { for: "q2_5_a1" }, "普通", -1);
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("label", {
    for: "q2_5_a2",
    style: { "margin-left": "6px" }
}, "当座", -1);
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_48 = {
    key: 4,
    class: "err"
};
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "口座名義", -1);
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("span", null, "（半角ｶﾅ）", -1);
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_52 = {
    key: 5,
    class: "err"
};
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "口座番号", -1);
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("span", null, "（半角数字7桁）", -1);
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("span", null, "6桁の口座をお持ちの方は左に0を追加して7桁でご入力ください。", -1);
const _hoisted_57 = {
    key: 6,
    class: "err"
};
import { ref, reactive, watch, computed, onMounted, nextTick } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import ImageFrame from '@component/ImageFrame.vue';
import { PayeeUpdatedType } from '@util/Consts';
import { isObjEmpty } from '@util/Common';
export default /*#__PURE__*/ _defineComponent({
    __name: 'payee_entry',
    props: {
        common: null,
        errors: null,
        payee: null
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const form = reactive({
            update_type: PayeeUpdatedType.PAYEE,
            user_id: props.common.user_id,
            receive: (_a = props.payee.receive) !== null && _a !== void 0 ? _a : true,
            bank_code: props.payee.bank_code,
            institution_name: props.payee.institution_name,
            branch_code: props.payee.branch_code,
            branch_name: props.payee.branch_name,
            account_type: props.payee.account_type,
            account_number: props.payee.account_number.toString(),
            account_holder: props.payee.account_holder,
        });
        const tempForm = reactive({
            update_type: PayeeUpdatedType.PAYEE,
            user_id: props.common.user_id,
            receive: (_b = props.payee.receive) !== null && _b !== void 0 ? _b : true,
            bank_code: props.payee.bank_code,
            institution_name: props.payee.institution_name,
            branch_code: props.payee.branch_code,
            branch_name: props.payee.branch_name,
            account_type: props.payee.account_type,
            account_number: props.payee.account_number.toString(),
            account_holder: props.payee.account_holder,
        });
        // const showReceived = computed(() => {
        //     return form.receive ? '受け取る' : '受け取らない';
        // });
        const showTypeName = computed(() => {
            return form.account_type === 1 ? '普通' : '当座';
        });
        const showAccountCode = computed(() => {
            var _a, _b;
            if (!(form === null || form === void 0 ? void 0 : form.account_number)) {
                return '';
            }
            const partition = -3;
            const end = (_a = form === null || form === void 0 ? void 0 : form.account_number) === null || _a === void 0 ? void 0 : _a.slice(partition);
            const start = (_b = form === null || form === void 0 ? void 0 : form.account_number) === null || _b === void 0 ? void 0 : _b.slice(0, partition);
            return `${start.replace(/[0-9]/g, '*')}${end}`;
        });
        watch(() => tempForm.bank_code, () => {
            const pattern = /[^0-9]/g;
            tempForm.bank_code = tempForm.bank_code.replace(pattern, '');
        });
        watch(() => tempForm.branch_code, () => {
            const pattern = /[^0-9]/g;
            tempForm.branch_code = tempForm.branch_code.replace(pattern, '');
        });
        watch(() => tempForm.account_number, () => {
            const pattern = /[^0-9]/g;
            tempForm.account_number = tempForm.account_number.replace(pattern, '');
        });
        // 文字数チェック
        watch(() => tempForm.institution_name, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.institution_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.branch_name, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.branch_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.account_holder, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.account_holder = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        const onClickReceiveCancel = () => {
            tempForm.receive = form.receive;
        };
        const onClickCancel = () => {
            tempForm.bank_code = form.bank_code;
            tempForm.institution_name = form.institution_name;
            tempForm.branch_code = form.branch_code;
            tempForm.branch_name = form.branch_name;
            tempForm.account_type = form.account_type;
            tempForm.account_number = form.account_number;
            tempForm.account_holder = form.account_holder;
            validate.shot = false;
        };
        const onClickReceiveOk = () => {
            form.receive = tempForm.receive;
        };
        const close = ref();
        const validate = reactive({ shot: false });
        const onClickOk = () => {
            form.bank_code = tempForm.bank_code;
            form.institution_name = tempForm.institution_name;
            form.branch_code = tempForm.branch_code;
            form.branch_name = tempForm.branch_name;
            form.account_type = tempForm.account_type;
            form.account_number = tempForm.account_number;
            form.account_holder = tempForm.account_holder;
            Inertia.post(route('mentor.payee.update'), Object.assign({}, form), {
                onSuccess: () => {
                    close.value.click();
                },
                onError: () => { validate.shot = true; }
            });
        };
        onMounted(() => {
            validate.shot = isObjEmpty(props.errors);
            nextTick(() => {
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("dl", _hoisted_6, [
                                    _hoisted_7,
                                    _createElementVNode("dd", null, [
                                        _hoisted_8,
                                        _createTextVNode(" " + _toDisplayString(form.institution_name) + " ", 1),
                                        _hoisted_9,
                                        _createTextVNode(" " + _toDisplayString(form.branch_name) + " ", 1),
                                        _hoisted_10,
                                        _createTextVNode(" " + _toDisplayString(_unref(showTypeName)) + " ", 1),
                                        _hoisted_11,
                                        _createTextVNode(" " + _toDisplayString(form.account_holder) + " ", 1),
                                        _hoisted_12,
                                        _createTextVNode(" " + _toDisplayString(_unref(showAccountCode)) + " ", 1),
                                        _hoisted_13
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("form", null, [
                            _createElementVNode("div", _hoisted_14, [
                                _hoisted_15,
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                        _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        _hoisted_19,
                                        _createElementVNode("div", _hoisted_20, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tempForm.receive) = $event)),
                                                value: true,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q1",
                                                id: "q1_a1"
                                            }, null, 512), [
                                                [_vModelRadio, tempForm.receive]
                                            ]),
                                            _hoisted_21,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((tempForm.receive) = $event)),
                                                value: false,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q1",
                                                id: "q1_a2"
                                            }, null, 512), [
                                                [_vModelRadio, tempForm.receive]
                                            ]),
                                            _hoisted_22
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_modal_close bt_clear",
                                                        onClick: onClickReceiveCancel
                                                    }, "キャンセル")
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_ok",
                                                        onClick: onClickReceiveOk
                                                    }, "OK")
                                                ])
                                            ]),
                                            _createElementVNode("p", {
                                                class: "bt_modal_close",
                                                ref_key: "close",
                                                ref: close,
                                                style: { "display": "none" }
                                            }, null, 512)
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", {
                                    class: "modal-bg bt_modal_close",
                                    onClick: onClickCancel
                                }),
                                _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                        _createVNode(ImageFrame, {
                                            src: "images/common/i_bt_close.svg",
                                            onClick: onClickCancel
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_27, [
                                        _hoisted_28,
                                        _createElementVNode("div", _hoisted_29, [
                                            _hoisted_30,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((tempForm.bank_code) = $event)),
                                                type: "text",
                                                name: "q2_1",
                                                class: "w20 inquiry-form",
                                                maxlength: "4"
                                            }, null, 512), [
                                                [_vModelText, tempForm.bank_code]
                                            ]),
                                            _hoisted_31,
                                            _hoisted_32,
                                            (validate.shot && ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.bank_code))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(props.errors.bank_code), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_34,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((tempForm.institution_name) = $event)),
                                                type: "text",
                                                name: "q2_2",
                                                class: "w60 inquiry-form",
                                                placeholder: "例：みずほ銀行"
                                            }, null, 512), [
                                                [_vModelText, tempForm.institution_name]
                                            ]),
                                            _hoisted_35,
                                            (validate.shot && ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.institution_name))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(props.errors.institution_name), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_37,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((tempForm.branch_code) = $event)),
                                                type: "text",
                                                name: "q2_3",
                                                class: "w20 inquiry-form",
                                                maxlength: "3"
                                            }, null, 512), [
                                                [_vModelText, tempForm.branch_code]
                                            ]),
                                            _hoisted_38,
                                            _hoisted_39,
                                            (validate.shot && ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.branch_code))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(props.errors.branch_code), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_41,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((tempForm.branch_name) = $event)),
                                                type: "text",
                                                name: "q2_4",
                                                class: "f_corp wmax inquiry-form",
                                                placeholder: "例：品川支店"
                                            }, null, 512), [
                                                [_vModelText, tempForm.branch_name]
                                            ]),
                                            _hoisted_42,
                                            (validate.shot && ((_d = props.errors) === null || _d === void 0 ? void 0 : _d.branch_name))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(props.errors.branch_name), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_44,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((tempForm.account_type) = $event)),
                                                value: 1,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q2_5",
                                                id: "q2_5_a1"
                                            }, null, 512), [
                                                [_vModelRadio, tempForm.account_type]
                                            ]),
                                            _hoisted_45,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((tempForm.account_type) = $event)),
                                                value: 2,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q2_5",
                                                id: "q2_5_a2"
                                            }, null, 512), [
                                                [_vModelRadio, tempForm.account_type]
                                            ]),
                                            _hoisted_46,
                                            _hoisted_47,
                                            (validate.shot && ((_e = props.errors) === null || _e === void 0 ? void 0 : _e.account_type))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(props.errors.account_type), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_49,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((tempForm.account_holder) = $event)),
                                                type: "text",
                                                name: "q2_7",
                                                class: "f_corp w50 inquiry-form",
                                                placeholder: "例：ﾔﾏﾀﾞ ﾀﾛｳ"
                                            }, null, 512), [
                                                [_vModelText, tempForm.account_holder]
                                            ]),
                                            _hoisted_50,
                                            _hoisted_51,
                                            (validate.shot && ((_f = props.errors) === null || _f === void 0 ? void 0 : _f.account_holder))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(props.errors.account_holder), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_53,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((tempForm.account_number) = $event)),
                                                type: "text",
                                                name: "q2_8",
                                                class: "f_corp w40 inquiry-form",
                                                placeholder: "例：0000000",
                                                maxlength: "7"
                                            }, null, 512), [
                                                [_vModelText, tempForm.account_number]
                                            ]),
                                            _hoisted_54,
                                            _hoisted_55,
                                            _hoisted_56,
                                            (validate.shot && ((_g = props.errors) === null || _g === void 0 ? void 0 : _g.account_number))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(props.errors.account_number), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", { class: "bt_box clear" }, [
                                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_modal_close bt_clear",
                                                        onClick: onClickCancel
                                                    }, "キャンセル")
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_ok",
                                                        onClick: onClickOk
                                                    }, "OK")
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
